<div>
    <div class="grid grid-cols-2 text-center gap-2 mb-2">
        <div class="spike-card">
            <div class="font-bold mb-2">Capital Gain Inv.</div>
            <div class="grid grid-cols-2">
                <div>
                    <div>Lordo</div>
                    <div class="font-bold">{{ (investmentRecap().quantity > 0 ? investmentRecap().capitalGainInvested : null) | currency:'EUR' }}</div>
                    <div class="text-xs">{{ investmentRecap().percInv | percent:'1.2-2' }}</div>
                </div>
                <div>
                    <div>Netto (Tax)</div>
                    <div class="font-bold">{{ (investmentRecap().quantity > 0 ? investmentRecap().taxedCapitalGainInvested : null) | currency:'EUR' }}</div>
                    <div class="text-xs">{{ investmentRecap().percInvTax | percent:'1.2-2' }}</div>
                </div>
            </div>
        </div>
        
        <div class="spike-card"> 
            <div class="font-bold mb-2">Capital Gain Tot.</div>
            <div class="grid grid-cols-2">
                <div>
                    <div>Lordo</div>
                    <div class="font-bold">{{ investmentRecap().capitalGainTotal | currency:'EUR' }}</div>
                    <div class="text-xs">{{ investmentRecap().percTotal | percent:'1.2-2' }}</div>
                </div>
                <div>
                    <div>Netto (Tax)</div>
                    <div class="font-bold">{{ investmentRecap().taxedCapitalGainTotal | currency:'EUR' }}</div>
                    <div class="text-xs">{{ investmentRecap().percTotalTax | percent:'1.2-2' }}</div>
                </div>
            </div>
        </div>
    </div>


    <div class="grid grid-cols-5 gap-2 spike-card">
        <div></div>
        <div class="text-right font-bold">Quote</div>
        <div class="text-right font-bold">Valore medio</div>
        <div class="text-right font-bold">Valore</div>
        <div class="text-right font-bold">Commissioni</div>
        <div class="font-bold">Acquisto</div>
        <div class="text-right">{{ investmentRecap().quantityBuy }}</div>
        <div class="text-right">{{ investmentRecap().buyMidPrice | currency:'EUR' }}</div>
        <div class="text-right">{{ investmentRecap().totalPurchaseValue | currency:'EUR' }}</div>
        <div class="text-right ">{{ investmentRecap().buyCommissionCost | currency:'EUR' }}</div>
        <div class="font-bold">Vendita</div>
        <div class="text-right">{{ investmentRecap().quantitySell ? -investmentRecap().quantitySell : 0 }}</div>
        <div class="text-right">{{ investmentRecap().sellMidPrice | currency:'EUR' }}</div>
        <div class="text-right">{{ investmentRecap().totalSelledValue | currency:'EUR' }}</div>
        <div class="text-right ">{{ investmentRecap().sellCommissionCost | currency:'EUR' }}</div>
        <div class="font-bold">Dividendi</div>
        <div class="text-right">-</div>
        <div class="text-right">{{ investmentRecap().dividendMidPrice | currency:'EUR' }}</div>
        <div class="text-right">{{ investmentRecap().totalDividendValue | currency:'EUR' }}</div>
        <div class="text-right">{{ investmentRecap().dividendCommissionCost | currency:'EUR' }}</div>
        <div class="font-bold">Totale</div>
        <div class="text-right">{{ investmentRecap().quantity }}</div>
        <div class="text-right">-</div>
        <div class="text-right">{{ investmentRecap().totalActualValue | currency:'EUR' }}</div>
        <div class="text-right">{{ investmentRecap().totalCommissionCost | currency:'EUR' }}</div>
    </div>
</div>